module.exports = __webpack_public_path__ + "img/info-v.7ab4377e.jpg";